module.exports = __webpack_public_path__ + "img/Warlock-orc-m-70.63da7a08.gif";